import { AudioManager } from "../../AudioManager";
import { Button } from "../../utils/Button";
import { ShopContainer } from "./ShopContainer";

export class PaginationButton extends Phaser.GameObjects.Container {

    public static RIGHT = "right";
    public static LEFT = "left";

    private onButton: Button;
    private offButton: Phaser.GameObjects.Image;
    private side: string;
    private shopContainer: ShopContainer;

    constructor(scene: Phaser.Scene, side: string, shopContainer: ShopContainer) {
        
        super(scene);

        this.side = side;
        this.shopContainer = shopContainer;

        if (this.side === PaginationButton.RIGHT) {
            this.scaleX = -1;
        }

        this.onButton = new Button(this.scene, 0, 0, "texture_atlas_1", "btn_back_off", "btn_back_on");
        this.onButton.onDown(this.onClickButton, this);
        this.add(this.onButton);

        this.offButton = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_back_disabled_off");
        this.add(this.offButton);
    }

    public activate(): void {

        this.onButton.visible = true;
        this.offButton.visible = false;
    }

    public deactivate(): void {

        this.onButton.visible = false;
        this.offButton.visible = true;
    }

    private onClickButton(): void { 

        AudioManager.playSound("click_btn");
        
        this.shopContainer.onClickPaginationButton(this.side);
    }
}
